import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import ru from './locales/ru.json'

const SUPPORTED_LANGUAGES = ['en', 'ru'] as const
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

function isSupportedLanguage(lang: string): lang is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(lang)
}

/**
 * Detect language from Telegram WebApp or browser.
 * Priority: Telegram language > browser language > 'en'
 */
function getTelegramLanguage(): string | undefined {
  try {
    const lang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
    if (lang && isSupportedLanguage(lang)) {
      return lang
    }
  } catch {
    // Not in Telegram context
  }
  return undefined
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    lng: getTelegramLanguage(),
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export { i18n, SUPPORTED_LANGUAGES }
export type { SupportedLanguage }
